import { ICSIDUserStatus } from "../../store/csid/types";

enum SSN_STATUS {
    REQUIRED = "REQUIRED",
    NOT_REQUIRED = "NOT_REQUIRED",
    LAST4SSN_FAILED = "LAST4SSN_FAILED",
    FULLSSN_FAILED = "FULLSSN_FAILED",
    SSN_SUCCESS = "SSN_SUCCESS",
}

enum CSID_ACTIVATION_STATUS {
    ACTIVATION_REQUIRED = "ACTIVATION_REQUIRED",
    ACTIVATED = "ACTIVATED",
    DEACTIVATED = "DEACTIVATED",
    NONE = "NONE",
}

enum AUTHENTICATION_STATUS {
    PENDING = "PENDING",
    AUTHENTICATED = "AUTHENTICATED",
    NONE = "NONE",
    MARK_FOR_MANUAL_AUTH = "MARK_FOR_MANUAL_AUTH",
}

enum PRODUCT_AUTHENTICATION_TYPE {
    L3AUTH = "L3AUTH",
    NONL3AUTH = "NONL3AUTH",
    NONE = "NONE",
}

export enum NEXT_STEP {
    CAPTURE_LAST_4_SSN = "CAPTURE_LAST_4_SSN",
    CAPTURE_FULL_SSN = "CAPTURE_FULL_SSN",
    TRIGGER_L3_AUTHENTICATION = "TRIGGER_L3_AUTHENTICATION",
    GO_TO_DASHBOARD = "GO_TO_DASHBOARD",
    SHOW_TO_CALL_IN = "SHOW_TO_CALL_IN",
}

export const getNextStep = (csidUserStatus: ICSIDUserStatus): NEXT_STEP => {
    // be on safe side show message to call
    let returnValue: NEXT_STEP = NEXT_STEP.SHOW_TO_CALL_IN;
    if (csidUserStatus != null) {
        let ssnStatus: string = csidUserStatus["ssn-status"];
        let csidActivationStatus: string = csidUserStatus["csidActivationStatus"];
        let authenticationStatus: string = csidUserStatus["auth-status"];
        let productAuthenticationType: string = csidUserStatus["productAuthenticationType"];

        if (ssnStatus != null) {
            ssnStatus = ssnStatus.trim().toUpperCase();
        }
        if (csidActivationStatus != null) {
            csidActivationStatus = csidActivationStatus.trim().toUpperCase();
        }
        if (authenticationStatus != null) {
            authenticationStatus = authenticationStatus.trim().toUpperCase();
        }
        if (productAuthenticationType != null) {
            productAuthenticationType = productAuthenticationType.trim().toUpperCase();
        }

        const SSNStatus: SSN_STATUS = ssnStatus as SSN_STATUS;
        const CSIDActivationStatus: CSID_ACTIVATION_STATUS = csidActivationStatus as CSID_ACTIVATION_STATUS;
        const AuthenticationStatus: AUTHENTICATION_STATUS = authenticationStatus as AUTHENTICATION_STATUS;
        const ProductAuthenticationType: PRODUCT_AUTHENTICATION_TYPE = productAuthenticationType as PRODUCT_AUTHENTICATION_TYPE;
        // https://ezshield.jira.com/wiki/spaces/CGW/pages/190324413/SSN+Pinning+Technical+Designs

        if (
            SSNStatus === SSN_STATUS.REQUIRED &&
            ProductAuthenticationType === PRODUCT_AUTHENTICATION_TYPE.L3AUTH &&
            CSIDActivationStatus === CSID_ACTIVATION_STATUS.ACTIVATION_REQUIRED &&
            AuthenticationStatus === AUTHENTICATION_STATUS.PENDING
        ) {
            returnValue = NEXT_STEP.CAPTURE_FULL_SSN;
        } else if (
            SSNStatus === SSN_STATUS.LAST4SSN_FAILED &&
            ProductAuthenticationType === PRODUCT_AUTHENTICATION_TYPE.L3AUTH &&
            CSIDActivationStatus === CSID_ACTIVATION_STATUS.ACTIVATION_REQUIRED &&
            AuthenticationStatus === AUTHENTICATION_STATUS.PENDING
        ) {
            returnValue = NEXT_STEP.CAPTURE_FULL_SSN;
        } else if (
            SSNStatus === SSN_STATUS.REQUIRED &&
            ProductAuthenticationType === PRODUCT_AUTHENTICATION_TYPE.L3AUTH &&
            CSIDActivationStatus === CSID_ACTIVATION_STATUS.ACTIVATED &&
            AuthenticationStatus === AUTHENTICATION_STATUS.PENDING
        ) {
            returnValue = NEXT_STEP.CAPTURE_FULL_SSN;
        } else if (
            (SSNStatus === SSN_STATUS.NOT_REQUIRED || SSNStatus === SSN_STATUS.SSN_SUCCESS) &&
            ProductAuthenticationType === PRODUCT_AUTHENTICATION_TYPE.L3AUTH &&
            CSIDActivationStatus === CSID_ACTIVATION_STATUS.ACTIVATED &&
            AuthenticationStatus === AUTHENTICATION_STATUS.PENDING
        ) {
            returnValue = NEXT_STEP.TRIGGER_L3_AUTHENTICATION;
        } else if (
            (SSNStatus === SSN_STATUS.NOT_REQUIRED || SSNStatus === SSN_STATUS.SSN_SUCCESS) &&
            ProductAuthenticationType === PRODUCT_AUTHENTICATION_TYPE.L3AUTH &&
            CSIDActivationStatus === CSID_ACTIVATION_STATUS.ACTIVATED &&
            AuthenticationStatus === AUTHENTICATION_STATUS.AUTHENTICATED
        ) {
            returnValue = NEXT_STEP.GO_TO_DASHBOARD;
        } else if (
            (SSNStatus === SSN_STATUS.NOT_REQUIRED || SSNStatus === SSN_STATUS.SSN_SUCCESS) &&
            ProductAuthenticationType === PRODUCT_AUTHENTICATION_TYPE.NONL3AUTH &&
            CSIDActivationStatus === CSID_ACTIVATION_STATUS.ACTIVATED &&
            AuthenticationStatus === AUTHENTICATION_STATUS.NONE
        ) {
            returnValue = NEXT_STEP.GO_TO_DASHBOARD;
        } else if (
            (SSNStatus === SSN_STATUS.NOT_REQUIRED || SSNStatus === SSN_STATUS.SSN_SUCCESS) &&
            ProductAuthenticationType === PRODUCT_AUTHENTICATION_TYPE.NONE &&
            (CSIDActivationStatus === CSID_ACTIVATION_STATUS.DEACTIVATED || CSIDActivationStatus === CSID_ACTIVATION_STATUS.NONE) &&
            (AuthenticationStatus === AUTHENTICATION_STATUS.NONE ||
                AuthenticationStatus === AUTHENTICATION_STATUS.AUTHENTICATED ||
                AuthenticationStatus === AUTHENTICATION_STATUS.PENDING ||
                AuthenticationStatus === AUTHENTICATION_STATUS.MARK_FOR_MANUAL_AUTH)
        ) {
            returnValue = NEXT_STEP.GO_TO_DASHBOARD;
        } else if (
            SSNStatus === SSN_STATUS.FULLSSN_FAILED &&
            ProductAuthenticationType === PRODUCT_AUTHENTICATION_TYPE.L3AUTH &&
            CSIDActivationStatus === CSID_ACTIVATION_STATUS.ACTIVATION_REQUIRED &&
            AuthenticationStatus === AUTHENTICATION_STATUS.PENDING
        ) {
            returnValue = NEXT_STEP.SHOW_TO_CALL_IN;
        } else if (
            SSNStatus === SSN_STATUS.FULLSSN_FAILED &&
            ProductAuthenticationType === PRODUCT_AUTHENTICATION_TYPE.L3AUTH &&
            CSIDActivationStatus === CSID_ACTIVATION_STATUS.ACTIVATED &&
            AuthenticationStatus === AUTHENTICATION_STATUS.PENDING
        ) {
            returnValue = NEXT_STEP.SHOW_TO_CALL_IN;
        } else if (
            (SSNStatus === SSN_STATUS.NOT_REQUIRED || SSNStatus === SSN_STATUS.SSN_SUCCESS) &&
            ProductAuthenticationType === PRODUCT_AUTHENTICATION_TYPE.L3AUTH &&
            CSIDActivationStatus === CSID_ACTIVATION_STATUS.ACTIVATED &&
            AuthenticationStatus === AUTHENTICATION_STATUS.MARK_FOR_MANUAL_AUTH
        ) {
            returnValue = NEXT_STEP.SHOW_TO_CALL_IN;
        }
    }
    return returnValue;
};
